export default requester => {
    return {
        /**
         * Image Analysis.
         *
         * @param  {object}  params
         * @return {object}
         */
        imageAnalysis(params = {}) {
            return requester.get('/tools/image-analyzer', { params });
        },

        /**
         * Scrape an article.
         */
        scrapeArticle(params = {}) {
            return requester.get('/scrape-article', { params });
        },
    };
}
